// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"44":"5493d502","655":"45c74996","722":"0a168320"}[chunkId] + ".js";
};